import { AutoWidthCenter } from '../../../../components/layout/AutoWidthCenter'
import { Box, Button, Divider, Heading, HStack } from '@chakra-ui/react'
import { DefaultContactForm } from '../../../../components/secure/contacts/DefaultContactForm'
import { GetDefaultContact } from '../../../../api/calls/contacts/ContactQueries'
import { history } from '../../../../ApplicationRouter'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

export const EditDefaultContact = () => {
  let { id } = useParams();

  const { data } = useQuery(['default-contact', id], () => GetDefaultContact(id), { enabled: !!id });

  return (
    <AutoWidthCenter>
      <Box py="5">
        <HStack pb="5" justifyContent="space-between">
          <Heading as="h1">Edit default contact</Heading>
          <Button onClick={() => history.back()}>Back</Button>
        </HStack>
        <Divider />
        {data && <DefaultContactForm defaultContact={data} />}
      </Box>
    </AutoWidthCenter>
  )
}